export default {
  nav: {
    dashboard: 'Главная',
    markets: 'Рынки',
    trade: 'Торговать',
    support: 'Поддержка',
    profile: 'Профиль'
  },
  trade: {
    title: 'Торговля',
    spot: 'Спот',
    futures: 'Фьючерсы',
    copytrading: 'Копитрейдинг',
    leaderboard: 'Лидерборд',
    myTraders: 'Мои трейдеры',
    myTrades: 'Мои сделки',
    becomeTrader: 'Стать трейдером',
    buy: 'Купить',
    sell: 'Продать',
    price: 'Цена',
    amount: 'Количество',
    total: 'Итого',
    available: 'Доступно',
    margin: 'Маржа',
    leverage: 'Плечо',
    orderType: 'Тип ордера',
    limit: 'Лимит',
    market: 'Рынок',
    tpsl: 'TP/SL',
    openChart: 'Открыть график',
    selectToken: 'Выбрать токен',
    positionsHistory: 'История позиций',
    processing: 'Обработка...',
    positionOpened: 'Позиция открыта',
    orderPlaced: 'Лимитный ордер выставлен',
    positionClosed: 'Позиция закрыта: {pnl}',
    orderCanceled: 'Ордер отменён',
    tpSlUpdated: 'TP/SL обновлён',
    editTpSl: 'Изменить TP/SL',
    tpProfitLabel: 'Тейк-профит (цена)',
    slLossLabel: 'Стоп-лосс (цена)',
    tpSlUsdtNote: 'Укажите ЦЕНУ срабатывания: Take Profit — цена закрытия в плюс, Stop Loss — цена закрытия в минус. Для лонга TP выше цены входа, SL ниже; для шорта — наоборот.',
    save: 'Сохранить',
    closePosition: 'Закрыть',
    confirmCloseTitle: 'Закрытие позиции',
    confirmCloseMessage: 'Вы уверены, что хотите закрыть эту позицию по рыночной цене?',
    confirmClose: 'Подтвердить закрытие',
    confirmOpenTitle: 'Открытие позиции',
    confirmOpenMessage: 'Вы уверены, что хотите открыть эту позицию?',
    confirmOrderTitle: 'Размещение лимитного ордера',
    confirmOrderMessage: 'Вы уверены, что хотите разместить этот лимитный ордер?',
    confirmCancelTitle: 'Отмена ордера',
    confirmCancelMessage: 'Вы уверены, что хотите отменить этот ордер?',
    confirmCancelOrder: 'Подтвердить отмену',
    confirm: 'Подтвердить',
    tradingBlockedTitle: 'Торговля ограничена',
    tradingBlockedMessage: 'Уважаемый пользователь! По вашему торговому счёту зафиксирован критически низкий уровень маржи. В целях защиты ваших средств и предотвращения дальнейших убытков, возможность открытия и закрытия позиций временно ограничена. Пожалуйста, свяжитесь с поддержкой для решения данного вопроса и восстановления доступа к торговым операциям.',
    understood: 'Понятно',
    pair: 'Пара',
    direction: 'Направление',
    limitPriceLabel: 'Цена лимита',
    cancel: 'Отмена',
    copyTrade: 'Копитрейд',
    cancelOrder: 'Отменить',
    positionsTab: 'Позиции',
    historyTab: 'История',
    copyCannotCloseTitle: 'Уважаемый пользователь',
    copyCannotCloseText: 'Данную позицию невозможно закрыть вручную, поскольку она была открыта в рамках копитрейдинга. Сделка будет автоматически закрыта только после того, как трейдер, за которым вы следуете, закроет соответствующую позицию на своём счёте.',
    openOrders: 'Отложенные ордера',
    noOpenPositions: 'Нет открытых позиций',
    noOpenOrders: 'Нет отложенных ордеров',
    entryPrice: 'Вход',
    markPrice: 'Маркир.',
    liqPrice: 'Цена ликв.',
    limitPrice: 'Цена лимита',
    marginUsed: 'Задействовано',
    equity: 'Капитал',
    unrealizedPnl: 'Нереализ. PnL',
    errorNoUser: 'Не удалось определить пользователя',
    errorEnterAmount: 'Введите корректную сумму',
    errorEnterPrice: 'Введите корректную цену лимита',
    errorInsufficient: 'Недостаточно доступного баланса',
    errorGeneric: 'Что-то пошло не так',
    errorNetwork: 'Ошибка сети. Попробуйте ещё раз',
    copyingActiveTitle: 'Копирование активно',
    copyingActiveMessage: 'Ваш кошелек подключён к копитрейдингу. В данный момент открытие сделок на спотовом и фьючерсном рынках недоступно, так как маржа задействована в активных позициях копирования.\n\nЧтобы восстановить торговлю, отключитесь от трейдера и остановите копирование сделок.',
    spotLockedTitle: 'Спотовая торговля',
    spotLockedText: 'Уважаемый пользователь,<br><br>Спотовая торговля доступна исключительно для пользователей со статусом <strong>VIP</strong> в приложении HyperLiquid Mini App.<br><br>Повышайте свой уровень активности и выполняйте требования программы лояльности. После достижения VIP-статуса доступ к спотовой торговле будет автоматически открыт.',
    spotYourLevel: 'Ваш уровень',
    spotToVip: 'до VIP',
    spotCurrent: 'Текущий',
    becomeTraderTitle: 'Стать трейдером',
    becomeTraderMessage: 'Чтобы стать копитрейдером и зарабатывать не только на собственных средствах, необходимо получить VIP-уровень аккаунта.\n\nVIP-статус открывает доступ к подключению подписчиков, позволяет масштабировать торговлю за счёт их капитала и получать дополнительное вознаграждение от прибыли по скопированным сделкам.',
    cannotCopyTitle: 'Невозможно копировать нескольких трейдеров',
    cannotCopyMessage: 'Вы не можете копировать нескольких трейдеров одновременно, так как ваш счёт ещё не достиг статуса Platinum.\n\nПолучите статус Platinum — и откройте возможность копировать сразу нескольких трейдеров и диверсифицировать стратегии.',
    copying: 'Копируете',
    copy: 'Копировать',
    roi: 'ROI',
    pnl: 'PnL',
    drawdown: 'Просадка',
    followers: 'Подписчики',
    ok: 'OK',
    close: 'Закрыть'
  },
  chart: {
    positionsPnl: 'Позиции ({n}) · Нереализ. PnL',
    unavailable: 'График в реальном времени недоступен для этого актива'
  },
  maintenance: {
    title: 'Уважаемые пользователи!',
    message1: 'В данный момент проводятся технические работы по оптимизации и улучшению системы.',
    message2: 'В связи с этим некоторые функции могут работать нестабильно или с временными ограничениями.',
    message3: 'Приложение продолжает работать в штатном режиме, доступ к основному функционалу сохраняется.',
    message4: 'Благодарим за понимание. Мы работаем над тем, чтобы всё функционировало максимально быстро и стабильно.',
    button: 'Понятно'
  },
  settings: {
    title: 'Настройки',
    language: 'Язык',
    theme: 'Тема',
    support: 'Поддержка',
    dark: 'Темная',
    light: 'Светлая'
  },
  profile: {
    title: 'Профиль',
    balance: 'Баланс',
    withdraw: 'Вывести',
    totalBalance: 'Ваш общий баланс активов',
    viewHistory: 'История транзакций',
    referrals: 'Рефералы',
    referralsCount: '{count} Рефералов',
    rewards: 'Награды',
    rewardsCount: '{count} Наград',
    rewardsMessage: 'Награды автоматически зачисляются на ваш баланс',
    yourCode: 'Ваш код:',
    copy: 'Копировать',
    copied: 'Скопировано!',
    pnl7d: '7D PnL',
    pnl30d: '30D PnL',
    pnl90d: '90D PnL',
    aum: 'AUM',
    roi: 'ROI',
    roi90d: 'ROI (90D)',
    unsubscribe: 'Отписаться',
    resume: 'Возобновить',
    resuming: 'Возобновление...',
    inactiveTitle: 'Ваш запрос успешно принят!',
    inactiveMessage: 'Средства будут разблокированы в течение 21 дня — это время необходимо для закрытия всех сделок, расчета прибыли и правильного завершения копирования. Это сделано для вашей безопасности и защиты капитала. Если вы хотите продолжить копирование этого трейдера, нажмите кнопку "Возобновить".',
    inviteButton: 'Пригласить реферала и копировать вместе!',
    referralLimitMessage: 'В настоящее время невозможно подключить новых рефералов к этому трейдеру. Он установил лимит на количество пользователей, которым разрешено копировать его сделки',
    ok: 'Ок',
    vipTier: 'VIP уровень',
    yourProgress: 'Ваш прогресс',
    currentTier: 'Текущий уровень',
    progressTooltip: 'Ваш прогресс уровня будет расти по мере увеличения вашей торговой активности, активности депозитов и общего торгового объема.',
    currentExp: 'Текущий EXP:',
    expToNext: 'EXP до следующего уровня:',
    maxLevel: 'Максимальный уровень достигнут!',
    unsubscribeConfirm: 'Прекратить копирование сделок трейдера? После отключения вы перестанете получать прибыль от их торговли.',
    no: 'Нет',
    yes: 'Да',
    processing: 'Обработка...',
    withdrawFunds: 'Вывести средства',
    confirmWithdrawal: 'Подтвердить вывод',
    enterPin: 'Введите PIN-код',
    pinDescription: 'Пожалуйста, введите ваш PIN-код для подтверждения вывода',
    network: 'Сеть',
    selectNetwork: 'Выберите сеть',
    walletAddress: 'Адрес кошелька',
    enterWallet: 'Введите адрес кошелька',
    amount: 'Сумма (USDT)',
    enterAmount: 'Введите сумму',
    available: 'Доступно:',
    minMax: 'Мин: {min} USDT | Макс: {max} USDT за транзакцию',
    cancel: 'Отмена',
    continue: 'Продолжить',
    confirm: 'Подтвердить',
    back: 'Назад',
    withdrawalSubmitted: 'Запрос на вывод отправлен',
    withdrawalMessage: 'Ваш запрос находится на рассмотрении, спасибо за ожидание',
    openPositionsErrorTitle: 'Уважаемый пользователь!',
    openDashboard: 'Открыть дашборд',
    openPositionsErrorMessage: 'Ваша заявка не была выполнена, так как на вашем аккаунте имеются открытые сделки с использованием кросс-маржи.\nПожалуйста, закройте все активные позиции и повторите попытку.',
    transactionHistory: 'История транзакций',
    loadingHistory: 'Загрузка истории...',
    noTransactions: 'Пока нет транзакций',
    deposit: 'Пополнение',
    withdrawal: 'Вывод',
    pending: 'Ожидание',
    approved: 'Одобрено',
    completed: 'Завершено',
    declined: 'Отклонено',
    failed: 'Ошибка',
    networkLabel: 'Сеть:',
    addressLabel: 'Адрес:',
    reasonLabel: 'Причина:',
    noReason: 'Причина не указана',
    na: 'Н/Д',
    levels: {
      bronze: {
        benefit1: 'Обычные торговые комиссии',
        benefit2: 'Стандартные лимиты на вывод',
        benefit3: 'Ежемесячные награды',
        benefit4: 'Маржинальная торговля до 3x плеча'
      },
      silver: {
        benefit1: 'На 5% ниже торговые комиссии',
        benefit2: 'Ежемесячные бонусы',
        benefit3: 'Маржинальная торговля до 5x плеча'
      },
      gold: {
        benefit1: 'На 10% ниже торговые комиссии',
        benefit2: 'Приоритетная поддержка клиентов',
        benefit3: 'Ранний доступ к новым инструментам',
        benefit4: 'Маржинальная торговля до 10x плеча'
      },
      platinum: {
        benefit1: 'На 25% ниже торговые комиссии',
        benefit2: 'Персональный менеджер счета',
        benefit3: 'Приглашения в приватные сообщества',
        benefit4: 'Маржинальная торговля до 50x плеча'
      },
      vip: {
        benefit1: 'Нулевые торговые комиссии',
        benefit2: 'Полный доступ к OTC стойке',
        benefit3: 'VIP менеджер 24/7',
        benefit4: 'Индивидуальные лимиты и условия',
        benefit5: 'Приглашения на приватные офлайн мероприятия',
        benefit6: 'Маржинальная торговля до 100x'
      }
    }
  },
  faq: {
    title: 'FAQ / Поддержка',
    footerText: 'Если вы не нашли ответ на свой вопрос, свяжитесь с',
    customerSupport: 'службой поддержки',
    footerEnd: "для получения дополнительной помощи. Или по электронной почте:",
    questions: {
      q1: 'Что такое копи-трейдинг?',
      q2: 'Как начать копировать трейдера?',
      q3: 'Могу ли я прекратить копирование в любое время?',
      q4: 'Кто контролирует мои средства?',
      q6: 'Что происходит, если трейдер уходит в убыток?',
      q7: 'Могу ли я копировать нескольких трейдеров одновременно?',
      q8: 'Как часто обновляется статистика трейдера?',
      q9: 'Где я могу посмотреть свои результаты?',
      q10: 'Может ли трейдер изменить свою стратегию?',
      q11: 'Безопасно ли копировать сделки?'
    },
    answers: {
      a1: 'Копи-трейдинг — это механизм, который автоматически зеркалирует сделки выбранного трейдера в реальном времени.',
      a2: 'Выберите трейдера, нажмите "Подключить" и подтвердите сумму, которую хотите выделить для копирования.',
      a3: 'Да, вы можете прекратить копирование и закрыть позиции в любое время, в соответствии с условиями трейдера.',
      a4: 'Ваши средства остаются на вашем личном кошельке/счете биржи. Трейдер не имеет к ним доступа.',
      a6: 'Убытки распределяются пропорционально вашей выделенной сумме. Трейдер не несет финансовой ответственности за результат.',
      a7: 'Да, если ваш баланс позволяет. Это может помочь диверсифицировать риски.',
      a8: 'Статистика обновляется в реальном времени или с минимальной задержкой.',
      a9: 'В разделе "Dashboard" или "Profile" вы можете найти подробную информацию о прибылях, убытках и активных позициях.',
      a10: 'Да, трейдеры могут свободно корректировать свою стратегию в любое время, и все изменения автоматически отражаются в скопированных сделках.',
      a11: 'Безопасность зависит от уровня риска выбранного трейдера. Мы рекомендуем изучить ROI, PnL и метрики риска перед подключением.'
    }
  },
  markets: {
    title: 'Рынки',
    searchPlaceholder: 'Поиск по названию или символу',
    loadingMarkets: 'Загрузка рынков…',
    unableToLoad: 'Не удалось загрузить рынки',
    tryAgain: 'Попробовать снова',
    nothingFound: 'Ничего не найдено',
    nothingFoundMessage: 'Попробуйте изменить параметры поиска или сортировки.',
    loading: 'Загрузка...',
    loadMore: 'Загрузить еще',
    chooseAsset: 'Выберите актив для просмотра информации',
    chooseAssetMessage: 'Выберите рынок из списка слева, чтобы увидеть здесь подробную информацию о цене и проекте.',
    sortSymbol: 'Символ',
    sortPrice: 'Цена',
    sort24h: '24ч %',
    sortVolume: 'Объем'
  },
  marketDetails: {
    loading: 'Загрузка...',
    loadingData: 'Загрузка данных рынка…',
    unableToLoad: 'Не удалось загрузить данные рынка',
    tryAgain: 'Попробовать снова',
    last24h: 'Последние 24 часа',
    priceChart: 'График цены',
    hoursAgo: '24ч назад',
    now: 'Сейчас',
    marketInfo: 'Информация о рынке',
    marketCap: 'Рыночная капитализация',
    circulatingSupply: 'Обращающееся предложение',
    volume24h: 'Объем за 24ч',
    projectInfo: 'Информация о проекте',
    marketIdNotProvided: 'ID рынка не указан',
    marketNotFound: 'Рынок не найден',
    errorLoading: 'Ошибка загрузки данных рынка'
  },
  dashboard: {
    title: 'Панель управления',
    periods: {
      today: 'Сегодня',
      week: 'Неделя',
      month: 'Месяц',
      allTime: 'Все время'
    },
    loadingData: 'Загрузка данных панели…',
    unableToLoad: 'Не удалось загрузить панель',
    tryAgain: 'Попробовать снова',
    totalBalance: 'Общий баланс',
    unrealizedPnl: 'Нереализованный PnL',
    realizedPnl: 'Реализованный PnL',
    totalRoi: 'Общий ROI',
    positions: 'Позиции',
    open: 'Открытые',
    closed: 'Закрытые',
    winRate: 'Процент успешных сделок',
    avgPnlVolume: 'Средний PnL / Объем',
    avgPnl: 'Средний PnL',
    volume: 'Объем',
    profitabilityChart: 'График прибыльности',
    openPositions: 'Открытые позиции',
    positionsHistory: 'История позиций',
    noOpenPositions: 'Нет открытых позиций',
    crossMargin: 'Кросс-маржа',
    leverage: 'Плечо',
    margin: 'Маржа',
    pnlUnrealized: 'PnL (Нереализованный)',
    coinHiddenAlert: 'Трейдер временно скрыл торговую пару, чтобы предотвратить инсайдерскую торговлю и несанкционированное распространение деталей сделки до закрытия позиции.',
    failedToGetUserId: 'Не удалось получить ID пользователя',
    failedToGetUserData: 'Не удалось получить данные пользователя',
    errorLoadingData: 'Ошибка загрузки данных панели',
    requestTimeout: 'Таймаут запроса'
  },
  positionsHistory: {
    title: 'История позиций',
    loadingHistory: 'Загрузка истории позиций…',
    unableToLoad: 'Не удалось загрузить позиции',
    tryAgain: 'Попробовать снова',
    noClosedPositions: 'Нет закрытых позиций',
    entryPrice: 'Цена входа',
    exitPrice: 'Цена выхода',
    margin: 'Маржа',
    realizedPnl: 'Реализованный PnL',
    leverage: 'Плечо',
    dateOpened: 'Дата открытия',
    dateClosed: 'Дата закрытия'
  },
  admin: {
    balanceDetails: {
      title: 'Детали баланса',
      loading: 'Загрузка данных о балансе...',
      noData: 'Нет достаточно данных для этого',
      balance: 'Баланс кошелька',
      equity: 'Общий баланс',
      availableBalance: 'Доступный баланс',
      unrealizedProfit: 'Нереализ. PnL',
      tradingCredit: 'Торговый кредит',
      marginUsed: 'Маржа в сделках',
      openPositions: 'Открытые позиции',
      close: 'Закрыть',
      edit: 'Редактировать',
      cancel: 'Отмена',
      save: 'Сохранить',
      balanceHint: 'Общая сумма баланса',
      tradingCreditHint: 'Сумма торгового кредита',
      readonlyNote: 'Следующие поля рассчитываются автоматически:',
      create: 'Создать данные баланса'
    }
  },
  common: {
    days: 'д',
    usdt: 'USDT'
  },
  deposit: {
    title: 'Депозит',
    selectToken: 'Выберите токен',
    selectNetwork: 'Выберите сеть',
    connected: 'Подключено',
    notConnected: 'Не подключено',
    token: 'Токен',
    network: 'Сеть',
    backToToken: 'Вернуться к выбору токена',
    loadingAddress: 'Загрузка адреса для пополнения...',
    noWalletTitle: 'Кошелек не подключен',
    noWalletMessage: 'Пожалуйста, подключите ваш кошелек через лендинг для получения пополнений.',
    copyAddress: 'Копировать адрес',
    copied: 'Скопировано!',
    warning1: 'Отправляйте только {token} ({network}) на этот адрес',
    warning2: 'Минимальное пополнение: {min} USDT',
    warning3: 'Средства зачисляются автоматически после подтверждения',
    warning4: 'Комиссия за пополнение не взимается'
  },
  blocked: {
    title: 'Уведомление о статусе HyperWallet',
    greeting: 'Уважаемый пользователь,',
    reason: 'В настоящее время ваш HyperWallet <strong>временно недоступен</strong> в связи с разрывом смарт-контрактного соединения между платформой и вашим криптовалютным кошельком.',
    action: 'Для восстановления полного функционала кошелька необходимо выполнить повторную активацию смарт-контрактного обеспечения.',
    contact: 'Пожалуйста, обратитесь в службу поддержки HyperLiquid для урегулирования данного вопроса.',
    thanks: 'Благодарим за понимание и сотрудничество.'
  }
}
